import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="auth-viewport">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <Result
          status="404"
          title="404"
          subTitle="This page does not exist."
          extra={
            <Button type="primary" onClick={() => navigate('/')}>
              Go home
            </Button>
          }
        />
      </div>
    </div>
  );
};

export default NotFound;
